import { NgModule, ModuleWithProviders, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';

import { filter, take } from 'rxjs/operators';


import { RuntimeConfigLoaderModule, RuntimeConfigLoaderService } from '@awp/core/config';

import { GoogleTagManagerLoaderService } from './google-tag-loader.services';

export function initGoogleTagManager(gtmLoader: GoogleTagManagerLoaderService, configSvc: RuntimeConfigLoaderService) {
	return () => {
    // Wait for appConfig to be loaded before we continue
    configSvc.changed
      .pipe(
        filter(p => p != null),
        take(1),
      )
      .subscribe(p => gtmLoader.load(p.GOOGLE_TAG));
  }
}

@NgModule({
  imports: [CommonModule, RuntimeConfigLoaderModule]
})
export class GoogleTagModule {

  static forRoot(): ModuleWithProviders {
    return {
      ngModule: GoogleTagModule,
      providers: [
        {
          provide: GoogleTagManagerLoaderService,
          useClass: GoogleTagManagerLoaderService
        },
        {
          provide: APP_INITIALIZER,
          useFactory: initGoogleTagManager,
          deps: [GoogleTagManagerLoaderService, RuntimeConfigLoaderService],
          multi: true
        }
      ]
    };
  }
}
